<template>
    <runtime-template-compiler :template="template" />
</template>

<script>

import grccms_megamenu from '../GrcComponents/grccms_megamenu.vue'
import grccms_topmenu from '../GrcComponents/grccms_topmenu.vue'
import grccms_slider from '../GrcComponents/grccms_slider.vue'
import grccms_bloglist from '../GrcComponents/grccms_bloglist.vue'
import grccms_counter from '../GrcComponents/grccms_counter.vue'
import grccms_accordion from '../GrcComponents/grccms_accordion.vue'
import grccms_subpage_rightcont from '../GrcComponents/grccms_subpage_rightcont.vue'
import frmszolgkeres from '../frmszolgkeres/frmszolgkeres.vue'
import frmlogin from '../frmlogin/frmlogin.vue'
import frmszemelyesadatok from '../frmszemelyesadatok/frmszemelyesadatok.vue'
import frmhozzatartozok from '../frmhozzatartozok/frmhozzatartozok.vue'
import frmkedvezmenyezettek from '../frmkedvezmenyezettek/frmkedvezmenyezettek.vue'
import frmjelszovaltoztatas from '../frmjelszovaltoztatas/frmjelszovaltoztatas.vue'
import frmelfelejtettjelszo from '../frmelfelejtettjelszo/frmelfelejtettjelszo.vue'
import frmjelszovisszaallitas from '../frmjelszovisszaallitas/frmjelszovisszaallitas.vue'
import frmertesitesbeallitas from '../frmertesitesbeallitas/frmertesitesbeallitas.vue'
import frmkepviselet from '../frmkepviselet/frmkepviselet.vue'
import frmegyeniszamla from '../frmegyeniszamla/frmegyeniszamla.vue'
import frmegeszsegkartya from '../frmegeszsegkartya/frmegeszsegkartya.vue'
import frmdashboard_epkartya from '../frmdashboard/frmdashboard_epkartya.vue'
import frmletolthetodokumentumok from '../frmletolthetodokumentumok/frmletolthetodokumentumok.vue'
import frmfeltoltottdokumentumok from '../frmfeltoltottdokumentumok/frmfeltoltottdokumentumok.vue'
import frmdokumentumfeltoltes from '../frmdokumentumfeltoltes/frmdokumentumfeltoltes.vue'
import frmbefizetes from '../frmbefizetes/frmbefizetes.vue'
import frmbefizetes_eredmeny from '../frmbefizetes_eredmeny/frmbefizetes_eredmeny.vue'
import frmteendok from '../frmteendok/frmteendok.vue'


export default {
  name: 'GrcCMSRENDER',
  components: {
    grccms_megamenu,
    grccms_topmenu,
    grccms_slider,
    grccms_bloglist,
    grccms_counter,
    grccms_accordion,
    grccms_subpage_rightcont,
    frmszolgkeres,
    frmlogin,
    frmszemelyesadatok,
    frmhozzatartozok,
    frmkedvezmenyezettek,
    frmjelszovaltoztatas,
    frmelfelejtettjelszo,
    frmjelszovisszaallitas,
    frmertesitesbeallitas,
    frmkepviselet,
    frmegyeniszamla,
    frmegeszsegkartya,
    frmdashboard_epkartya,
    frmletolthetodokumentumok,
    frmfeltoltottdokumentumok,
    frmdokumentumfeltoltes,
    frmbefizetes,
    frmbefizetes_eredmeny,
    frmteendok

    
  },
  props: {
  },
  data () {
      return {
        template: "",
      }
  },
  model: {
  },  
  methods:{


  },
  created()
  {
    //console.log("create: "+Date.now());
      this.template = gPageContent;
  },

  mounted()
  {
    this.$emit("render_mounted");
  }

}


</script>


<style scoped>


</style>